import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getSubdomain, buildWorkspaceUrl } from '../utils/subdomain';

const ProtectedRoute = ({ children }) => {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  const urlSubdomain = getSubdomain();

  // No subdomain in URL but user belongs to an org →
  // hard-redirect to their workspace (e.g. tekhub.localhost:3001).
  if (!urlSubdomain && user.organization_subdomain) {
    window.location.replace(
      buildWorkspaceUrl(user.organization_subdomain) + '/dashboard'
    );
    return null;
  }

  // Wrong subdomain → clear session and go to sign-in.
  if (urlSubdomain && user.organization_subdomain !== urlSubdomain) {
    logout();
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
